addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-warehouse-arrivals]').forEach(container => {
        const grid = container.querySelector('[data-arrivals-grid]');
        const search = container.querySelector('[data-arrivals-search]');
        const company = container.querySelector('[data-arrivals-company]');
        const status = container.querySelector('[data-arrivals-status]');
        const cards = container.querySelector('[data-arrivals-cards]');
        const feedback = container.querySelector('[data-arrivals-feedback]');
        const markingIcon = container.querySelector('[data-arrivals-marking-icon]');
        if (!grid || !search || !company || !status || !cards || !feedback) return;

        const url = window.FullioUrlState;
        let appliedSearch = '';
        let pendingXhr = null;
        const element = (tag, text, className = '') => {
            const node = document.createElement(tag);
            node.textContent = text ?? '';
            node.className = className;
            return node;
        };
        const link = (text, url) => {
            const node = element('a', text);
            const target = new URL(url, window.location.origin);
            if (target.origin === window.location.origin) node.href = target.href;
            return node;
        };
        const quantityNode = row => {
            const { received, expected, shortage, surplus } = row.quantity;
            const node = element('span', '');
            node.append(element('span', received, shortage > 0 ? 'text-danger' : (surplus > 0 ? 'text-warning-emphasis' : '')));
            if (expected !== null) node.append(` / ${expected}`);
            if (surplus > 0) node.append(element('span', ` (+${surplus})`, 'text-warning-emphasis'));
            return node;
        };
        const companyNode = row => {
            const node = element('span', row.company.code);
            node.title = row.company.name;
            return node;
        };
        const statusVariant = row => ({
            draft: 'secondary',
            pending_approval: 'warning',
            rejected: 'danger',
            expected: 'info',
            receiving: 'primary',
            problem: 'danger',
            completed: 'success',
            deleted: 'secondary'
        }[row.status.value] || 'secondary');
        const arrivalNode = row => {
            const node = element('div');
            const arrivalLink = link(row.code, row.url);
            arrivalLink.dataset.arrivalsMatch = '';
            node.append(arrivalLink);
            if (row.match && appliedSearch) {
                const preview = element('div', '', 'small mt-2');
                const skuContainer = element('span', '', 'text-nowrap');
                const sku = link(row.match.sku, row.match.url);
                sku.dataset.arrivalsMatch = '';
                const name = element('div', row.match.name);
                name.dataset.arrivalsMatch = '';
                skuContainer.append(sku);
                if (row.match.requiresMarking && markingIcon) {
                    skuContainer.append(' ', markingIcon.content.cloneNode(true));
                }
                preview.append(skuContainer, name);
                row.match.barcodes.forEach(barcode => {
                    const line = element('div', barcode, 'text-body-secondary font-monospace');
                    line.dataset.arrivalsMatch = '';
                    preview.append(line);
                });
                node.append(preview);
            }
            return node;
        };
        const showFeedback = (message, error = false, loading = false) => {
            feedback.replaceChildren();
            feedback.hidden = !message;
            feedback.classList.toggle('text-danger', error);
            feedback.classList.toggle('text-body-secondary', !error);
            if (loading) {
                const spinner = element('span', '', 'spinner-border spinner-border-sm me-2');
                feedback.append(spinner);
            }
            feedback.append(document.createTextNode(message));
        };
        const columns = [
            { data: 'company.code', orderable: false, render: (value, type, row) => type === 'display' ? companyNode(row) : value },
            { data: 'code', render: (value, type, row) => type === 'display' ? arrivalNode(row) : value },
            { data: 'number', render: DataTable.render.text() },
            { data: 'type.label', render: DataTable.render.text() },
            { data: 'status.label', render: DataTable.render.text() },
            { data: 'statusDate', render: DataTable.render.text() },
            { data: null, orderable: false, className: 'text-end text-nowrap', render: (value, type, row) => type === 'display' ? quantityNode(row) : quantityNode(row).textContent }
        ];
        const lengthMenu = [25, 50, 100];
        const defaultOrder = '-code';
        const parseOrder = value => {
            const index = columns.findIndex(column => column.orderable !== false && column.data === value.replace(/^-/, ''));
            return index < 0 ? null : [index, value.startsWith('-') ? 'desc' : 'asc'];
        };
        const urlLength = () => lengthMenu.includes(Number(url.get('length'))) ? Number(url.get('length')) : lengthMenu[0];
        const urlPage = () => Math.max(1, Math.floor(Number(url.get('page'))) || 1);
        const urlOrder = () => [parseOrder(url.get('order')) ?? parseOrder(defaultOrder)];
        const fillFilters = () => {
            url.fill(search, url.get('q'));
            url.fill(company, url.get('company'));
            url.fill(status, url.get('status'));
        };
        fillFilters();
        const table = new DataTable(grid, {
            serverSide: true,
            processing: false,
            search: { search: search.value.trim() },
            pageLength: urlLength(),
            displayStart: (urlPage() - 1) * urlLength(),
            lengthMenu,
            order: urlOrder(),
            orderMulti: false,
            autoWidth: false,
            layout: {
                topStart: null,
                topEnd: null,
                bottomStart: ['pageLength', 'info'],
                bottomEnd: { paging: { firstLast: false, previousNext: false, buttons: 5 } }
            },
            classes: {
                layout: {
                    row: 'dt-layout-row',
                    cell: 'dt-layout-cell',
                    tableCell: 'd-none d-md-block table-responsive',
                    start: 'dt-layout-start',
                    end: 'dt-layout-end',
                    full: 'dt-layout-full'
                }
            },
            ajax: {
                url: container.dataset.url,
                data: request => {
                    request.company = company.value;
                    request.status = status.value;
                },
                beforeSend: xhr => {
                    const previous = pendingXhr;
                    pendingXhr = xhr;
                    if (previous && previous.readyState !== 4) previous.abort();
                },
                error: (xhr, error) => {
                    if (xhr !== pendingXhr || error === 'abort') return;
                    showFeedback('Не удалось загрузить поставки. Попробуйте ещё раз.', true);
                    const retry = element('button', 'Повторить', 'btn btn-sm btn-outline-danger ms-2');
                    retry.type = 'button';
                    retry.addEventListener('click', () => table.ajax.reload(null, false));
                    feedback.append(retry);
                }
            },
            on: {
                preXhr: () => showFeedback('Загрузка…', false, true),
                xhr: (event, settings, json) => {
                    if (json && Number(json.draw) >= settings.drawCount) {
                        appliedSearch = settings.ajaxData.search.value;
                    }
                }
            },
            columns,
            language: {
                emptyTable: 'Поставок пока нет.',
                zeroRecords: 'Ничего не найдено.',
                processing: 'Загрузка…',
                loadingRecords: '',
                lengthMenu: 'По _MENU_',
                info: '_START_–_END_ из _TOTAL_',
                infoEmpty: '0 поставок',
                infoFiltered: '(всего _MAX_)',
                paginate: { first: 'Первая', previous: 'Назад', next: 'Далее', last: 'Последняя' }
            },
            createdRow: (node, row) => node.classList.add(`table-${statusVariant(row)}`),
            drawCallback: function () {
                const api = this.api();
                const info = api.page.info();
                if (info.page > 0 && info.start >= info.recordsDisplay) {
                    api.page('first').draw('page');
                    return;
                }
                const [order] = api.order();
                const orderValue = order?.[1] ? `${order[1] === 'desc' ? '-' : ''}${columns[order[0]].data}` : '';
                url.replace({
                    q: api.search(),
                    company: company.value,
                    status: status.value,
                    page: info.page > 0 ? info.page + 1 : '',
                    length: info.length !== lengthMenu[0] ? info.length : '',
                    order: orderValue !== defaultOrder ? orderValue : ''
                });
                container.querySelectorAll('.dt-paging').forEach(paging => {
                    paging.classList.toggle('d-none', info.pages < 2);
                });
                const rows = api.rows({ page: 'current' }).data().toArray();
                cards.replaceChildren();
                rows.forEach(row => {
                    const card = element('div', '', `card mb-3 bg-${statusVariant(row)}-subtle`);
                    const body = element('div', '', 'card-body');
                    const companyLine = element('div', 'Компания: ', 'small text-body-secondary mb-2');
                    companyLine.append(companyNode(row));
                    body.append(companyLine, arrivalNode(row));
                    const details = element('dl', '', 'row small mb-0 mt-3');
                    [
                        ['Номер поставки', row.number || '—'],
                        ['Тип', row.type.label],
                        ['Статус', row.status.label],
                        ['Дата статуса', row.statusDate],
                        [row.quantity.expected === null ? 'Принято, шт.' : 'Принято / заявлено, шт.', quantityNode(row)]
                    ].forEach(([label, value]) => {
                        const description = element('dd', '', 'col-7');
                        description.append(value);
                        details.append(element('dt', label, 'col-5'), description);
                    });
                    body.append(details);
                    card.append(body);
                    cards.append(card);
                });
                showFeedback('');
                if (!rows.length) {
                    cards.append(element('p', company.value || status.value || appliedSearch ? 'Ничего не найдено.' : 'Поставок пока нет.', 'text-center text-body-secondary py-3'));
                }
                if (appliedSearch && rows.length) {
                    new Mark(Array.from(container.querySelectorAll('[data-arrivals-match]'))).mark(appliedSearch, {
                        separateWordSearch: false,
                        caseSensitive: false,
                        diacritics: false,
                        className: 'stock-search-match'
                    });
                }
            }
        });
        search.addEventListener('input', DataTable.util.debounce(() => table.search(search.value.trim()).draw(), 350));
        [company, status].forEach(filter => filter.addEventListener('change', () => table.search(search.value.trim()).draw()));
        addEventListener('hashchange', () => {
            fillFilters();
            table.page.len(urlLength()).order(urlOrder()).search(search.value.trim());
            table.page(urlPage() - 1).draw(false);
        });
    });
});
